export const reviews = [
  {
    id: "7",
    name: "김태호",
    role: "직장인 · 물건분석 리포트 구매자",
    content: "리포트 덕분에 2천만원 아꼈습니다. 혼자 분석하려다 놓칠 뻔한 권리 하자를 리포트에서 미리 발견해서 입찰을 포기했는데, 실제로 그 물건 낙찰받은 분이 명도 소송 중이라는 소식을 들었어요. 강스터디 리포트는 진짜 돈 버는 투자입니다.",
    rating: 5,
    avatar: "https://img.echotwin.kr/kangstudy/16b49b06046962f8.jpg",
  },
  {
    id: "1",
    name: "김민수",
    role: "직장인 · 경매 입문 3개월차",
    content: "경매가 이렇게 쉬운 거였나 싶을 정도로 강의가 정말 친절해요. 권리분석이 제일 막막했는데 강스터디 덕분에 혼자서도 등기부등본 분석할 수 있게 됐습니다. 첫 낙찰 성공했어요!",
    rating: 5,
    avatar: "https://img.echotwin.kr/kangstudy/1e9d4d5c6c708aec.jpg",
  },
  {
    id: "2",
    name: "이지은",
    role: "주부 · 여성 투자자",
    content: "여자 혼자 경매 공부하기 막막했는데, 초보자 눈높이에 맞춘 설명이 정말 좋았어요. 물건분석 리포트 덕분에 안전한 물건만 골라서 투자하고 있습니다. 첫 수익 3천만 원 냈어요!",
    rating: 5,
    avatar: "https://img.echotwin.kr/kangstudy/5bf4fafc9d22244f.jpg",
  },
  {
    id: "3",
    name: "박성호",
    role: "은퇴자 · 노후 투자 준비",
    content: "은퇴 후 노후 대비 투자로 경매를 시작했는데, 강스터디의 실전반에서 배운 입찰가 산정법이 정말 실용적이에요. 무리하지 않고 꾸준히 수익 내는 법을 배웠습니다.",
    rating: 5,
    avatar: "https://img.echotwin.kr/kangstudy/552f11734f2379df.jpg",
  },
  {
    id: "4",
    name: "최유진",
    role: "매매사업자 · 5년차",
    content: "매매사업자 과정을 통해 세무 전략과 자금 조달 노하우를 배워 수익이 30% 이상 올랐어요. 1:1 상담도 정말 도움 많이 됐습니다. 강스터디는 제 비즈니스 파트너예요.",
    rating: 5,
    avatar: "https://img.echotwin.kr/kangstudy/87552926d761a6bb.jpg",
  },
  {
    id: "5",
    name: "정대호",
    role: "직장인 · 부수입 투자",
    content: "직장 다니면서 틈틈이 공부하기 좋은 구성이에요. 동영상 강의를 출퇴근 시간에 보고, 주말에 실전반 참여하는 식으로 공부 중입니다. 벌써 두 번째 물건 낙찰 받았어요.",
    rating: 5,
    avatar: "https://img.echotwin.kr/kangstudy/6953a856e4c6b066.jpg",
  },
  {
    id: "6",
    name: "한소희",
    role: "초보 투자자 · 1년차",
    content: "무료 강의만 들어도 경매 기본기는 충분히 익힐 수 있어요. 저는 무료 강의 듣고 자신감 붙어서 유료 강의까지 신청했습니다. 투자는 신중해야 하는데 강스터디가 길을 잘 알려줘요.",
    rating: 4,
    avatar: "https://img.echotwin.kr/kangstudy/60897f3189ffe6ab.jpg",
  },
];